import { formatImgSagGame } from './formatters';
import { getSagGameAttributes } from './formatters/attributes';
import { isSAGFlashVariant, isSAGHoldemSix, isSAGMax } from './formatters/helpers';
import isUltraStake from './formatters/ultraStakeSag';
import { legacyHandTypeToAssetNameMap } from './types';
import type { Language, RawGame, SagGame } from './types';

const numPlayers = (flags: number) => (isSAGMax(flags) ? '3-8' : '3');

const getPayoutAmount = (
  promoRef: string,
  sagPromoTicketShortText?: {
    texts: Record<string, string>;
  }
) => {
  if (!promoRef || promoRef.length === 0 || !sagPromoTicketShortText) return null;
  if (sagPromoTicketShortText && sagPromoTicketShortText.texts) {
    return {
      payoutAmount: sagPromoTicketShortText.texts['payout-amount'],
      payoutAmountSelected: sagPromoTicketShortText.texts['payout-amount-selected']
    };
  }
  return null;
};

const mapSagGames = ({
  information: {
    buyin: buyIn,
    rake,
    game,
    currency,
    maxPayout,
    maxPrizePool,
    flags,
    mods,
    scalePM,
    lobbyNewsContentData = null,
    promoRef,
    id,
    scriptId,
    sagPromoTicketShortText,
    tournSites
  },
  isPlayMoney,
  locale
}: {
  information: Pick<
    RawGame['information'],
    | 'buyin'
    | 'rake'
    | 'game'
    | 'currency'
    | 'maxPayout'
    | 'maxPrizePool'
    | 'flags'
    | 'mods'
    | 'scalePM'
    | 'promoRef'
    | 'id'
    | 'scriptId'
    | 'sagPromoTicketShortText'
    | 'tournSites'
  > & { lobbyNewsContentData?: { 'payout-amount': string } | null };
  locale: Language;
  isPlayMoney: boolean;
}) => ({
  id,
  scriptId,
  game: legacyHandTypeToAssetNameMap[game],
  isMax: isSAGMax(flags),
  isFlash: isSAGFlashVariant(flags),
  isHoldemSix: isSAGHoldemSix(game, flags, mods),
  promoRef,
  tournSites,
  isUltra: isUltraStake({
    buyIn,
    currency,
    maxWinnerPayout: maxPrizePool,
    promoRef,
    rake,
    scalePM,
    isPlayMoney
  }),
  imageUrl: formatImgSagGame({
    buyIn,
    rake,
    currency,
    scalePM,
    promoRef,
    maxPrizePool,
    game,
    flags,
    mods,
    isPlayMoney: Number(isPlayMoney)
  }),
  ...getSagGameAttributes(
    {
      buyIn,
      rake,
      currency,
      maxPrizePool: maxPayout,
      isPlayMoney: Number(isPlayMoney),
      players: numPlayers(flags),
      scalePM,
      lobbyNewsContentData,
      shortenRM: true
    },
    locale
  ),
  ...getPayoutAmount(promoRef, sagPromoTicketShortText)
});

const mapSagGamesFn = ({
  sagGames,
  locale,
  isPlayMoney
}: {
  sagGames: RawGame[];
  locale: Language;
  isPlayMoney: boolean;
}): SagGame[] =>
  sagGames.map(({ information }) => mapSagGames({ information, locale, isPlayMoney }));

export default mapSagGamesFn;
